import { MARKETPLACES } from '../config';

export function Retail() {
  return (
    <section id="retail" className="py-16 sm:py-24 px-4 bg-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-tea-900">
          Хотите попробовать перед оптом?
        </h2>
        <p className="mt-4 text-lg text-tea-600 max-w-xl mx-auto">
          Наш чай также доступен в розницу на маркетплейсах. 
          Идеально для знакомства с ассортиментом перед крупным заказом.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          {MARKETPLACES.map((m) => (
            <a
              key={m.name}
              href={m.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 rounded-xl border-2 border-tea-200 text-tea-700 font-semibold hover:border-tea-400 hover:bg-tea-50 transition-all hover:scale-105"
            >
              <span className="text-2xl">{m.icon}</span>
              <span>{m.name}</span>
            </a>
          ))}
        </div>
        <p className="mt-8 text-sm text-tea-500">
          Для оптовых заказов обращайтесь в Telegram — там выгоднее
        </p>
      </div>
    </section>
  );
}
